import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const XRGB: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    {...props}
  >
    <style>{'.st1{fill:#002677}'}</style>
    <g id="Layer_1">
      <path
        d="M7.87428 22.2252L3.81141 18.1622C2.65401 17.0048 2.65401 15.1283 3.81141 13.971L4.01881 13.7636C5.17621 12.6062 7.05268 12.6062 8.21008 13.7636L12.273 17.8264L7.87428 22.2252Z"
        fill="#002677"
      />
      <path
        d="M23.6795 6.42028L7.87451 22.2249L12.2734 26.6239L28.0783 10.8192C30.0378 8.85974 28.65 5.50928 25.8789 5.50928C25.054 5.50928 24.2628 5.83701 23.6795 6.42028Z"
        fill="#FF612B"
      />
    </g>
  </Box>
)
export default XRGB
